export const CART_VALIDATIONS_MESSAGES = {
  NO_CLIENT_ADDRESS: {
    title: "Você ainda não adicionou um endereço para entrega",
    message:
      "Adicione um endereço para configurarmos melhor as ofertas perto de você e volte as compras.",
  },
  STORE_CLOSED: {
    title: "Estabelecimento fechado",
    message:
      "O estabelecimento encontra-se fechado. Em breve ele estará disponível para você fazer suas compras.",
  },
  OUT_OFF_DELIVERY_AREA: {
    title: "Estabelecimento indisponível para seu endereço",
    message:
      "Você encontra-se fora da área de cobertura desse estabelecimento, favor selecionar outro estabelecimento que atenda sua área.",
  },
  DIFF_STORES_IN_CART: {
    title:
      "Você possui produtos de outro estabelecimento em seu carrinho! Deseja limpar o carrinho?",
    message: "Não é possível realizar compras em mais de um estabelecimento ao mesmo tempo.",
  },
  MIN_ORDER_VALUE: {
    title: "O pedido mínimo para esse estabelecimento é {minOrderValue} sem o custo do frete",
    message: "Deseja adicionar mais itens ao carrinho de compras?",
  },
  CLEAR_CART: {
    title: "Deseja realmente limpar o carrinho?",
    message: "Todos os items adicionados serão excluídos",
  },
  ERROR_SHIPMENT_VALUE: {
    title: "Entrega indisponível",
    message:
      "Não foi possível calcular o valor da sua entrega. Escolha outro endereço ou tente novamente mais tarde.",
  },
};

export const HELP_CENTRAL_MESSAGES = {
  ABOULT: {
    sessionTitle: "Sobre o iFeira",
    sessionData: [
      {
        title: "Quem somos?",
        message:
          "O iFeira é um aplicativo de marketplace e delivery de " +
          "compras de feira, que conecta você a estabelecimentos parceiros " +
          "por meio de geolocalização. Após selecionar o supermercado ou " +
          "mercadinho preferido e fazer as compras online, realizamos a " +
          "entrega em até duas horas ou no horário agendado, de forma rápida e segura.",
      },
      {
        title: "Como funcionamos?",
        message:
          "Após cadastrar um endereço de entrega, lhe indicaremos " +
          "os estabelecimentos mais próximos e também as melhores promoções " +
          "para você fazer sua feira onde quiser. Depois de montar sua compra, " +
          "lhe oferecemos a opção de pagar na entrega ou através do aplicativo, " +
          "com o cartão de crédito. Suas compras são feitas por um separador do " +
          "próprio estabelecimento, e entregue no local de sua escolha por um de " +
          "nossos entregadores.",
      },
      {
        title: "Como saber se meu endereço é atendido pelo iFeira?",
        message:
          "Após cadastrar um endereço válido, nosso sistema de geolocalização " +
          "lhe indicará os estabelecimentos mais próximos de você. Caso ainda não " +
          "tenha atendimento no seu bairro, por favor, deixe seu e-mail para lhe " +
          "avisarmos quando estivermos operando próximo a você.",
      },
    ],
  },
  ORDER: {
    sessionTitle: "Minhas Compras",
    sessionData: [
      {
        title: "Como fazer minha primeira compra?",
        message:
          "Cadastre um endereço de entrega, busque por estabelecimentos, produtos " +
          "ou promoções, selecione um de nossos estabelecimentos parceiros e monte " +
          "seu carrinho de compras. Na hora de escolher produtos a granel você pode " +
          "escolher o grau de madureza e deixar uma sugestão de separação. Depois, " +
          "basta escolher a melhor forma de pagamento, seja na entrega ou no app " +
          "com o cartão de crédito. Em caso de falta de produto no estabelecimento, " +
          "você deve escolher se o separador deverá trocar o produto por outro similar " +
          "ou entrar em contato contigo. Uma vez finalizada a compra, basta esperar seu " +
          "pedido ser entregue em sua porta.",
      },
      {
        title: "Meu pedido não foi entregue.",
        message:
          "Entre em contato com o estabelecimento onde você fez o seu pedido e " +
          "envie um e-mail para contato@ifeiraoficial.com.br com o título “Meu pedido " +
          "não foi entregue” relatando o ocorrido. O iFeira retornará o contato assim " +
          "que possível.",
      },
      {
        title: "O pedido veio errado ou faltou um produto?",
        message:
          "Entre em contato com o estabelecimento onde você fez o seu pedido e " +
          "envie um e-mail para contato@ifeira.com.br com o título “Pedido errado” " +
          "ou “Faltou um produto” relatando o ocorrido. O iFeira retornará o contato " +
          "assim que possível.",
      },
      {
        title: "Como escolher frutas e verduras no iFeira?",
        message:
          "Pesquise seu produto na busca da página principal ou na busca do " +
          "estabelecimento de sua preferência. Em seguida, clique na imagem do " +
          "produto para abrir a página de detalhes. Lá você deve selecionar o grau " +
          "de madureza do seu hortifruti e poderá sugerir para o separador como o " +
          "seu produto deve ser escolhido. Por fim, adicione o item no carrinho.",
      },
      {
        title: "Substituição ou cancelamento de produto.",
        message:
          "Primeiramente você precisará nos fornecer um número de contato, " +
          "para que o separador possa falar com você via Whatsapp e " +
          "efetuar a substituição por um produto similar, caso o produto em questão " +
          "esteja em falta, ou cancelar o produto, caso também não tenha um similar. " +
          "Após o contato, caso não haja retorno, nós tomaremos as mesmas medidas.",
      },
      {
        title: "Problemas com a qualidade do produto",
        message:
          "Entre em contato com o estabelecimento onde você fez o seu pedido e " +
          "envie um e-mail para contato@ifeiraoficial.com.br com o título “Problemas " +
          "com a qualidade do produto” relatando o ocorrido. O iFeira retornará o " +
          "contato assim que possível.",
      },
    ],
  },
  PAYMENT: {
    sessionTitle: "Pagamento",
    sessionData: [
      {
        title: "Quais são as formas de pagamento?",
        message:
          "Você pode optar por pagar em dinheiro ou cartão, no ato da entrega, ou " +
          "exclusivamente por cartão de crédito pelo app.",
      },
      {
        title: "Como funciona a reserva de pagamento?",
        message:
          "Assim que agendar um pedido, o valor já será reservado em seu cartão de " +
          "crédito, mas a cobrança será feita somente no ato da entrega das suas compras.",
      },
      {
        title: "E se o valor final for menor em relação ao valor de reserva?",
        message:
          "Pode acontecer do valor final ser menor em relação ao valor da reserva. " +
          "Por exemplo, se um determinado produto estiver indisponível no mercado, " +
          "o mesmo será retirado da cobrança final e o valor final cobrado será menor " +
          "que o valor inicial reservado.",
      },
      {
        title: "O que é verificação de R$ 1,00?",
        message:
          "Para sua segurança, sempre que você cadastra um cartão de crédito pela " +
          "primeira vez na plataforma do iFeira, fazemos uma checagem de R$1,00 que " +
          "será logo devolvida (estornada). Essa é uma forma de verificar que todas " +
          "as informações cadastradas estão corretas e que você poderá concluir sua " +
          "compra tranquilamente.",
      },
      {
        title: "Como recebo minha nota fiscal?",
        message:
          "A nota fiscal dos produtos do estabelecimento deve vir junto às compras " +
          "e a nota fiscal geral, com todos os itens, incluindo o frete, será enviada " +
          "por e-mail após confirmação de recebimento da feira.",
      },
      {
        title: "Problemas com a cobrança para pagementos no app.",
        message:
          "Entre em contato com o iFeira através do e-mail contato@ifeiraoficial.com.br, " +
          "com o título “Problemas com pagamento no app”, e relate o ocorrido.",
      },
    ],
  },
  PARTNERS: {
    sessionTitle: "Quero ser um parceiro",
    sessionData: [
      {
        title: "Sou um supermercado.",
        message:
          "Entre em contato através do e-mail contato@ifeiraoficial.com.br, com o " +
          "título “Parceria supermercado”.",
      },
      {
        title: "Sou outro estabelecimento",
        message:
          "Entre em contato através do e-mail contato@ifeiraoficial.com.br, com o " +
          "título “Parceria outro estabelecimento”.",
      },
    ],
  },
};
